<!--
 * @Author: ZS
 * @Date: 2020-06-05 15:30:42
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-02 11:11:09
 * @Description: file content
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-checkbox {
  font-size: 12px !important;
}
.el-checkbox /deep/ span .el-checkbox__label {
  font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue